import { Sidebar } from "./Sidebar";

export function AppShell({ children }: { children: React.ReactNode }) {
  return (
    <div className="tw-flex tw-h-screen tw-overflow-hidden">
      <Sidebar />
      <main className="tw-min-w-0 tw-flex-1 tw-overflow-auto tw-bg-background">{children}</main>
    </div>
  );
}
